document.addEventListener('DOMContentLoaded', function () {
  const variantRadios = document.querySelectorAll('input[type="radio"][data-variant-id]');
  const variantIdInput = document.querySelector('product-form-component form input[name="id"]');

  if (!variantRadios.length || !variantIdInput) return;

  const updateVariant = (e) => {
    const variantId = e.target.getAttribute('data-variant-id');
    if (variantId) {
      variantIdInput.value = variantId;
      variantIdInput.dispatchEvent(new Event('input', { bubbles: true }));
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      console.log("✅ Variant ID set to:", variantId);
    }
  };

  variantRadios.forEach(radio => {
    radio.addEventListener('change', updateVariant);
  });

  // Set initial correct variant on page load
  const checkedRadio = Array.from(variantRadios).find(r => r.checked);
  if (checkedRadio) {
    checkedRadio.dispatchEvent(new Event('change'));
  }
});
